{
  "account-not-existed-dialog": {
    "buttons": {
      "cancel": "Zrušit",
      "sign-up": "Zaregistrujte se"
    },
    "text": {
      "hint": "Pokud jste u nás noví, nejprve si prosím vytvořte účet!",
      "not-found-account-with-email": "S tímto e-mailem není spojen žádný účet {{ email }}",
      "not-found-account-with-phone-nr": "S tímto telefonním číslem není žádný účet {{ phoneNr }}",
      "title": "Účet neexistuje"
    }
  }
}
